import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rate-change-modal"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "Revenue vs Lost revenue", -1);
const _hoisted_4 = {
  class: "body"
};
const _hoisted_5 = {
  class: "frame gained"
};
const _hoisted_6 = {
  class: "value-group"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "Revenue", -1);
const _hoisted_8 = {
  class: "value"
};
const _hoisted_9 = {
  class: "frame"
};
const _hoisted_10 = {
  class: "frame lost"
};
const _hoisted_11 = {
  class: "value-group lost"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "Lost revenue", -1);
const _hoisted_13 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("article", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _renderSlot(_ctx.$slots, "date", {
    class: "date"
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_renderSlot(_ctx.$slots, "gained")])])]), _createElementVNode("section", _hoisted_9, [_renderSlot(_ctx.$slots, "default")]), _createElementVNode("section", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_renderSlot(_ctx.$slots, "lost")])])])])]);
}